// Vendor imports
const React = require('react')
// Browser-specific vendor imports
let Stickyfill
if (typeof window === 'object') {
  Stickyfill = require('stickyfill')()
}

function useStickyfill() {
  if (!Stickyfill) {
    return
  }
  const domRef = React.useRef(null)
  React.useEffect(() => {
    const el = domRef.current
    if (el) {
      Stickyfill.add(el)
      return () => {
        Stickyfill.remove(el)
      }
    }
  })
  return domRef
}

module.exports = useStickyfill
